// Drifting sparkles for the princess theme.
export function Sparkles() {
  return (
    <div className="theme-decoration theme-decoration-sparkles" aria-hidden="true">
      <span className="sparkle sparkle-1">✨</span>
      <span className="sparkle sparkle-2">💖</span>
      <span className="sparkle sparkle-3">✨</span>
      <span className="sparkle sparkle-4">👑</span>
      <span className="sparkle sparkle-5">✨</span>
    </div>
  );
}
